import { getProviderWithBroadband } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const slug = route.params.provider;
  await $apolloQuery(getProviderWithBroadband, { slug }).then(provider => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const title = store.$i18n.t('provider.title', { providerName: provider.name });
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/broadband', '/compare-tv-broadband-phone/'],
      ['i18n/providers', '/compare-tv-broadband-phone/providers'], provider.name
    ]);
    store.commit('pageContent/setHead', { title });
    store.commit('providers/set', provider);
  }).catch(_ => {
    redirect(301, app.localePath('/compare-tv-broadband-phone/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.providerNotFound') });
  });
};
